(function () {
  let MutationObserver

  // eslint-disable-next-line no-eq-null
  if(window.MutationObserver != null) {
    return
  }

  // eslint-disable-next-line prefer-const
  MutationObserver = (function () {
    function MutationObserver(callBack) {
      // @ts-ignore
      this.callBack = callBack
    }

    MutationObserver.prototype.observe = function (element, options) {
      this.element = element
      // eslint-disable-next-line no-return-assign
      return this.interval = setInterval((function (_this) {
        return function () {
          let html
          // eslint-disable-next-line prefer-const
          html = _this.element.innerHTML
          if(html !== _this.oldHtml) {
            _this.oldHtml = html
            return _this.callBack.apply(null)
          }
        }
      })(this), 200)
    }

    MutationObserver.prototype.disconnect = function () {
      return window.clearInterval(this.interval)
    }

    return MutationObserver

  })()

  window.MutationObserver = MutationObserver

}).call(this)
